@if (initialized) {
  @if (bidSheet?.id) {
    <div class="row">
      <div class="mat-headline-5">
        <!-- {{bidSheet.name}} -->
      </div>
      <div class="icons">
        @if (downloading) {
          <mat-spinner strokeWidth="3" diameter="32" mode="indeterminate" color="accent">
          </mat-spinner>
        }
        @if (!downloading) {
          <button mat-icon-button [disabled]="!('read' | able: bidSheet)" (click)="downloadBidItems(bidSheet)"
            title="Download bid sheet" color="accent">
            <mat-icon>download</mat-icon>
          </button>
        }
        <app-file-uploader [disabled]="!('create' | able: newBidItem)" param="inputFile" [targetClass]="clsBidItem"
          [target]="csvEndpoint" icon="file_upload" accept="text/csv" (onError)="onUploadError($event)"
          (complete)="onUploadComplete($event)" title="Upload csv">
        </app-file-uploader>
        <button mat-icon-button [disabled]="!('create' | able: newBidItem)" (click)="openBidItemEdit(newBidItem)"
          title="Add bid item" color="accent">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
  }
  @if (!bidItems.length) {
    <div class="mat-body-strong">
      Found no records to show
    </div>
  }
  <!-- list -->
  <div class="list">
    @for (bidItem of bidItems; track bidItem) {
      <div class="list-card">
        <!-- actions -->
        <div class="hover-icons">
          <a mat-mini-fab [disabled]="!('update' | able: bidItem)" (click)="openBidItemEdit(bidItem)" color="accent"
            aria-label="Edit {{bidItem.item}}" title="Edit {{bidItem.item}}">
            <mat-icon>edit</mat-icon>
          </a>
          <button mat-mini-fab [disabled]="!('delete' | able: bidItem)" (click)="delete(bidItem)" color="warn"
            aria-label="Delete {{bidItem.item}}" title="Delete {{bidItem.item}}">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        <!-- /actions -->
        <div class="body">
          <div class="mat-headline-6 row">
            <div>{{bidItem.item}}</div>
            <div>Quantity: {{bidItem.quantity}}</div>
            <div>Unit Price: {{bidItem.unit_price}}</div>
            <div>UOM: {{bidItem.uom}}</div>
            @if (bidItem?.site?.id) {
              <div>
                Site: {{bidItem?.site?.name}}
              </div>
            }
          </div>
          <div class="mat-caption">{{bidItem.description}}</div>
        </div>
      </div>
    }
  </div>
  <!-- ./list -->
  @if (initialized && pagination.length && bidItems.length) {
    <mat-paginator (page)="pageChanged($event)"
      [length]="pagination.length" [pageIndex]="pagination.pageIndex" [pageSize]="pagination.pageSize">
    </mat-paginator>
  }
}
